import { useState, useEffect } from "react";
import DatePicker from "react-multi-date-picker";
import Slider, { Range } from "rc-slider";
import "rc-slider/assets/index.css";
import { GithubPicker } from "react-color";
import DatePanel from "react-multi-date-picker/plugins/date_panel";
import persian from "react-date-object/calendars/persian";
import persian_fa from "react-date-object/locales/persian_fa";
import Select, { StylesConfig } from "react-select";
import sendRequest from "hooks/useAxios";
import CreatableSelect from "react-select/creatable";
import { articleDataToQuery, productDataToQuery } from "utils/helperFunctions";
import chroma from "chroma-js";
import toast from "react-hot-toast";
import { addCommas } from "@persian-tools/persian-tools";

const dot = (color = "transparent") => ({
  alignItems: "center",
  display: "flex",

  ":before": {
    backgroundColor: color,
    borderRadius: 10,
    content: '" "',
    display: "block",
    marginRight: 8,
    height: 10,
    width: 10,
  },
});

const colourStyles: StylesConfig = {
  control: (styles) => ({ ...styles, backgroundColor: "white" }),
  option: (styles, { data, isDisabled, isFocused, isSelected }) => {
    const color = chroma(data.color);
    return {
      ...styles,
      backgroundColor: isSelected
        ? data.color
        : isFocused
        ? color.alpha(0.1).css()
        : undefined,
      color: isSelected ? chroma.contrast(color, "white") : data.color,
      cursor: "pointer",

      ":active": {
        ...styles[":active"],
        backgroundColor: isSelected ? data.color : color.alpha(0.3).css(),
      },
    };
  },
  input: (styles) => ({ ...styles, border: "none" }),
  singleValue: (styles, { data }) => ({ ...styles, ...dot(data.color) }),
};
function Modal({
  type,
  id,
  idConfig,
  modalData,
  setUpdater,
  brandList,
  tagList,
  blogHashtags,
  colorList,
}) {
  const [articleData, setArticleData] = useState({
    title: "",
    tags: [],
    dateRange: [],
    toggleDisplay: true,
  });
  const [productData, setProductData] = useState({
    title: "",
    tags: [],
    brands: [],
    priceRange: [0, 0],
    rankRange: [0, 0],
    color: [],
    sortTypes: {
      inventory: false,
      discounted: false,
      cheapest: false,
      mostExpensive: false,
      newest: false,
    },
    toggleDisplay: true,
  });
  useEffect(() => {
    if (modalData != undefined && type == "1") {
      let tag = [];
      if (typeof modalData.tags[0] == "object") {
        tag = modalData.tags.map((t) => t.value);
      } else {
        tag = [...modalData.tags];
      }
      setArticleData({
        ...modalData,
        tags: tag,
      });
    } else if (modalData != undefined && type != "1") {
      let tag = [];
      let brand = [];
      let color = [];
      if (typeof modalData.tags[0] == "object") {
        tag = modalData.tags.map((t) => t.value);
      } else {
        tag = [...modalData.tags];
      }
      if (typeof modalData.brands[0] == "object") {
        brand = modalData.brands.map((t) => t.value);
      } else {
        brand = [...modalData.brands];
      }
      if (typeof modalData.color[0] == "object") {
        color = modalData.color.map((t) => t.value);
      } else {
        color = [...modalData.color];
      }
      setProductData({
        ...modalData,
        tags: tag,
        brands: brand,
        color: color,
      });
    }
  }, [modalData]);

  const saveArticleString = (string) => {
    sendRequest("Update_boxs_configs", {
      conditions: `pagecode/=/${idConfig.pagecode}@@boxcode/=/${idConfig.boxcode}`,
      keyvalues: `toggle_display,${
        articleData.toggleDisplay ? 1 : 0
      }@@custom_config,${string}@@title,${articleData.title}`,
    }).then(({ data }) => {
      if (data.status == 1) {
        document.querySelector(".edit-list-modal .close-button").click();
        toast.success("با موفقیت ویرایش شد.");
        setUpdater((prev) => !prev);
      } else {
        toast.error("مشکلی در ویرایش پیش آمده است.");
      }
    });
  };
  const saveProductString = (string) => {
    sendRequest("Update_boxs_configs", {
      conditions: `pagecode/=/${idConfig.pagecode}@@boxcode/=/${idConfig.boxcode}`,
      keyvalues: `toggle_display,${
        productData.toggleDisplay ? 1 : 0
      }@@custom_config,${string}@@title,${productData.title}`,
    }).then(({ data }) => {
      if (data.status == 1) {
        document.querySelector(".edit-list-modal .close-button").click();
        toast.success("با موفقیت ویرایش شد.");
        setUpdater((prev) => !prev);
      } else {
        toast.error("مشکلی در ویرایش پیش آمده است.");
      }
    });
  };

  const insertHashtags = (arrayList) => {
    return Promise.all(
      arrayList.map((value) => {
        if (value.__isNew__ == true) {
          sendRequest("Insert_hashtags", { txt: value.label });
        }
      })
    );
  };
  const insertBrands = (arrayList) => {
    return Promise.all(
      arrayList.map((value) => {
        if (value.__isNew__ == true) {
          sendRequest("Insert_brand", { name: value.label });
        }
      })
    );
  };
  const valueOfSelect = (array, value) => {
    let temp = [];
    for (let i = 0; i < value.length; i++) {
      let x = array.filter((v) => v.value == value[i]);
      temp = [...temp, ...x];
    }
    return temp;
  };

  // 1 means blog
  const editModalJSX = () => {
    if (type == 1) {
      return (
        <>
          <div className="w-100 d-flex flex-row  item-input">
            <label
              htmlFor={`edit-modal-title-${id}`}
              className="form-lable pt-1"
            >
              عنوان :
            </label>
            <input
              id={`edit-modal-title-${id}`}
              type="text"
              value={articleData.title}
              onChange={(e) => {
                setArticleData((prev) => {
                  return { ...prev, title: e.target.value };
                });
              }}
              className="form-control w-50 mx-2"
              style={{ height: "33px" }}
            />
          </div>
          <div className="w-100 d-flex flex-row  item-input">
            <label htmlFor={`edit-modal-tag-${id}`} className="form-lable pt-1">
              تگ :
            </label>
            <CreatableSelect
              isMulti
              className="my-container"
              id={`edit-modal-tag-${id}`}
              options={tagList}
              // value={articleData.tags}
              value={valueOfSelect(tagList, articleData.tags)}
              onChange={(values) => {
                setArticleData((prev) => {
                  return { ...prev, tags: values.map((v) => v.value) };
                });
              }}
            />
          </div>
          <div className="w-100 d-flex flex-row  item-input mt-3">
            <label
              htmlFor={`edit-modal-date-${id}`}
              className="form-lable pt-1"
            >
              رنج تاریخ :
            </label>
            <DatePicker
              range
              plugins={[<DatePanel position="left" />]}
              calendar={persian}
              locale={persian_fa}
              calendarPosition="bottom-right"
              id={`edit-modal-date-${id}`}
              value={articleData.dateRange}
              onChange={(e) => {
                setArticleData((prev) => {
                  return { ...prev, dateRange: [...e] };
                });
              }}
            />
          </div>
          <div className="w-100 d-flex flex-row  item-input form-check form-switch ps-0 ">
            <label
              htmlFor={`edit-modal-displayToggle-${id}`}
              className=" form-check-label"
            >
              نمایش :
            </label>

            <input
              class="form-check-input ms-1"
              type="checkbox"
              id={`edit-modal-displayToggle-${id}`}
              onChange={(e) => {
                setArticleData((prev) => {
                  let temp = { ...prev };
                  temp.toggleDisplay = e.target.checked;
                  return { ...temp };
                });
              }}
              checked={articleData.toggleDisplay}
              style={{ float: "none" }}
            />
          </div>
        </>
      );
    } else {
      return (
        <>
          <div className="w-100 d-flex flex-row  item-input">
            <label
              htmlFor={`edit-modal-title-${id}`}
              className="form-lable pt-1"
            >
              عنوان :
            </label>
            <input
              id={`edit-modal-title-${id}`}
              type="text"
              value={productData.title}
              onChange={(e) => {
                setProductData((prev) => {
                  return { ...prev, title: e.target.value };
                });
              }}
              className="form-control w-50 mx-2"
              style={{ height: "33px" }}
            />
          </div>

          <div className="w-100 d-flex flex-row  item-input">
            <label htmlFor={`edit-modal-tag-${id}`} className="form-lable pt-1">
              تگ :
            </label>
            <CreatableSelect
              isMulti
              className="my-container"
              id={`edit-modal-tag-${id}`}
              options={tagList}
              // value={productData.tags}
              value={valueOfSelect(tagList, productData.tags)}
              onChange={(values) => {
                setProductData((prev) => {
                  return { ...prev, tags: values.map((v) => v.value) };
                });
              }}
            />
          </div>
          <div className="w-100 d-flex flex-row  item-input">
            <label
              htmlFor={`edit-modal-brand-${id}`}
              className="form-lable pt-1"
            >
              برند :
            </label>
            <CreatableSelect
              isMulti
              className="my-container"
              options={brandList}
              id={`edit-modal-brand-${id}`}
              value={valueOfSelect(brandList, productData.brands)}
              onChange={(values) => {
                setProductData((prev) => {
                  return { ...prev, brands: values.map((v) => v.value) };
                });
              }}
            />
          </div>
          <div className="w-100 d-flex flex-row  item-input mt-3">
            <label
              htmlFor={`edit-modal-brand-${id}`}
              className="form-lable pt-1"
            >
              امتیاز :
            </label>
            <Slider
              range
              min={0}
              max={5}
              marks={{ 1: 1, 2: 2, 3: 3, 4: 4, 5: 5 }}
              step={0.5}
              reverse
              value={productData.rankRange}
              onChange={(value) => {
                setProductData((prev) => {
                  return { ...prev, rankRange: [...value] };
                });
              }}
            />
          </div>
          <div className="w-100 d-flex flex-row  item-input mb-4 mt-3">
            <label
              htmlFor={`edit-modal-brand-${id}`}
              className="form-lable pt-1"
            >
              قیمت :
            </label>
            <div className="w-100 text-center">
              <Slider
                range
                min={0}
                max={100000000}
                // value={priceValue}
                step={1000000}
                reverse
                value={productData.priceRange}
                onChange={(value) => {
                  setProductData((prev) => {
                    return { ...prev, priceRange: [...value] };
                  });
                }}
              />
              <div>
                <p>
                  از {addCommas(productData.priceRange[0])} تومان تا
                  {addCommas(productData.priceRange[1])} تومان
                </p>
              </div>
            </div>
          </div>

          <div className="w-100 d-flex flex-row  item-input">
            <label
              htmlFor={`edit-modal-color-${id}`}
              className="form-lable pt-1"
            >
              رنگ :
            </label>
            <div style={{ width: "234px" }}>
              <Select
                styles={colourStyles}
                id={`edit-modal-color-${id}`}
                options={colorList}
                isMulti
                value={valueOfSelect(colorList, productData.color)}
                onChange={(color) => {
                  setProductData((prev) => {
                    return {
                      ...prev,
                      color: color.map((value) => value.value),
                    };
                  });
                }}
              ></Select>
            </div>
          </div>
          <div className="row">
            <div className="col-4 d-flex flex-row  item-input form-check form-switch ps-3 mt-3">
              <label
                htmlFor={`flexSwitchCheckDefault-${id}`}
                className=" form-check-label"
              >
                موجودی :
              </label>

              <input
                class="form-check-input ms-1"
                type="checkbox"
                id={`flexSwitchCheckDefault-${id}`}
                style={{ float: "none" }}
                checked={productData.sortTypes.inventory}
                onChange={(value) => {
                  setProductData((prev) => {
                    let temp = { ...prev };
                    temp.sortTypes.inventory = value.target.checked;
                    return { ...temp };
                  });
                }}
              />
            </div>
            <div className="col-4 d-flex flex-row  item-input form-check form-switch ps-0 mt-3">
              <label
                htmlFor={`edit-modal-discount-${id}`}
                className=" form-check-label"
              >
                تخفیف دار :
              </label>

              <input
                class="form-check-input ms-1"
                type="checkbox"
                id={`edit-modal-discount-${id}`}
                checked={productData.sortTypes.discounted}
                onChange={(value) => {
                  setProductData((prev) => {
                    let temp = { ...prev };
                    temp.sortTypes.discounted = value.target.checked;
                    return { ...temp };
                  });
                }}
                style={{ float: "none" }}
              />
            </div>
            <div className="col-4 mt-3 d-flex flex-row  item-input form-check form-switch ps-0 ">
              <label
                htmlFor={`edit-modal-displayToggle-${id}`}
                className=" form-check-label"
              >
                نمایش :
              </label>

              <input
                class="form-check-input ms-1"
                type="checkbox"
                id={`edit-modal-displayToggle-${id}`}
                onChange={(e) => {
                  setProductData((prev) => {
                    let temp = { ...prev };
                    temp.toggleDisplay = e.target.checked;

                    return { ...temp };
                  });
                }}
                checked={productData.toggleDisplay}
                style={{ float: "none" }}
              />
            </div>
          </div>

          <p>مرتب سازی براساس : </p>
          <div className="row">
            <div className="col-4 d-flex flex-row  item-input form-check form-switch ps-3 ">
              <label
                htmlFor={`edit-modal-cheapest-${id}`}
                className=" form-check-label"
              >
                ارزانترین :
              </label>

              <input
                class="form-check-input ms-1"
                type="checkbox"
                id={`edit-modal-cheapest-${id}`}
                onChange={(e) => {
                  setProductData((prev) => {
                    if (
                      (e.target.checked &&
                        productData.sortTypes.mostExpensive) ||
                      (e.target.checked && productData.sortTypes.newest)
                    ) {
                      let temp = { ...prev };
                      temp.sortTypes.cheapest = true;
                      temp.sortTypes.mostExpensive = false;
                      temp.sortTypes.newest = false;

                      return { ...temp };
                    } else {
                      let temp = { ...prev };
                      temp.sortTypes.cheapest = e.target.checked;

                      return { ...temp };
                    }
                  });
                }}
                checked={productData.sortTypes.cheapest}
                style={{ float: "none" }}
              />
            </div>

            <div className="col-4 d-flex flex-row  item-input form-check form-switch ps-0 ">
              <label
                htmlFor={`edit-modal-most-expensive-${id}`}
                className=" form-check-label"
              >
                گرانترین :
              </label>

              <input
                class="form-check-input ms-1"
                type="checkbox"
                id={`edit-modal-most-expensive-${id}`}
                style={{ float: "none" }}
                onChange={(e) => {
                  setProductData((prev) => {
                    if (
                      (e.target.checked && productData.sortTypes.cheapest) ||
                      (e.target.checked && productData.sortTypes.newest)
                    ) {
                      let temp = { ...prev };
                      temp.sortTypes.cheapest = false;
                      temp.sortTypes.newest = false;

                      temp.sortTypes.mostExpensive = true;

                      return { ...temp };
                    } else {
                      let temp = { ...prev };
                      temp.sortTypes.mostExpensive = e.target.checked;

                      return { ...temp };
                    }
                  });
                }}
                checked={productData.sortTypes.mostExpensive}
              />
            </div>
            <div className="col-4 d-flex flex-row  item-input form-check form-switch ps-0">
              <label
                htmlFor={`edit-modal-newest-${id}`}
                className=" form-check-label"
              >
                جدیدترین :
              </label>

              <input
                class="form-check-input ms-1"
                type="checkbox"
                id={`edit-modal-newest-${id}`}
                style={{ float: "none" }}
                checked={productData.sortTypes.newest}
                onChange={(e) => {
                  setProductData((prev) => {
                    if (
                      (e.target.checked && productData.sortTypes.cheapest) ||
                      (e.target.checked && productData.sortTypes.mostExpensive)
                    ) {
                      let temp = { ...prev };
                      temp.sortTypes.cheapest = false;
                      temp.sortTypes.mostExpensive = false;

                      temp.sortTypes.newest = true;

                      return { ...temp };
                    } else {
                      let temp = { ...prev };
                      temp.sortTypes.newest = e.target.checked;

                      return { ...temp };
                    }
                  });
                }}
              />
            </div>
          </div>
        </>
      );
    }
  };
  // console.log("rrr", articleData);
  return (
    <>
      {/* modall */}

      <div>
        <div className="modal fade edit-list-modal" id={`Modal${id}`}>
          <div className="modal-dialog">
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title" id="exampleModalLabel">
                  ویرایش
                </h5>
                <button
                  type="button"
                  className="btn-close"
                  data-bs-dismiss="modal"
                  aria-label="Close"
                />
              </div>
              <div className="modal-body">{editModalJSX()}</div>
              <div className="modal-footer">
                <button
                  type="button"
                  className="btn btn-secondary close-button"
                  data-bs-dismiss="modal"
                >
                  بستن
                </button>
                <button
                  onClick={() => {
                    if (type == 1) {
                      insertHashtags(articleData.tags);

                      saveArticleString(
                        articleDataToQuery(
                          {
                            ...articleData,
                            tags: valueOfSelect(tagList, articleData.tags),
                          },
                          false
                        )
                      );
                    } else {
                      insertHashtags(productData.tags);
                      insertBrands(productData.brands);
                      saveProductString(
                        productDataToQuery(
                          {
                            ...productData,
                            tags: valueOfSelect(tagList, productData.tags),
                            brands: valueOfSelect(
                              brandList,
                              productData.brands
                            ),
                            color: valueOfSelect(colorList, productData.color),
                          },
                          false
                        )
                      );
                    }
                  }}
                  type="button"
                  className="btn btn-primary"
                  data-bs-dismiss="modal"
                >
                  ذخیره
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default Modal;
